export default {};
throw new Error(`Could not resolve "@coinbase/wallet-sdk" imported by "@wagmi/connectors". Is it installed?`)